import './App.css';

import Preview from './components/Preview';
import Content from './components/Content';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

function App() {
    return (
        <div>
            <Preview />
            <Content />
            <FAQ />
            <Footer />
        </div>
    );
}

export default App;
